<template>
  <Modal
    :is-visible="isVisible"
    no-cancel
    :tracking="{
      action: 'checkout',
      topicKey: 'scratchcard_sold_out',
    }"
    @confirm="navigateToLocalized('/play-now/scratchcards')"
  >
    <template #headline>
      {{ $t('scratchcard.soldoutmodal.headline') }}
    </template>

    <template #confirm>
      {{ $t('scratchcard.soldoutmodal.confirm') }}
    </template>

    <div class="flex flex-col gap-200 items-center">
      <p>{{ $t('scratchcard.soldoutmodal.message') }}</p>
      <Illustration name="sold-out" />
    </div>
  </Modal>
</template>

<script lang="ts" setup>
type ScratchcardSoldOutModalProps = {
  isVisible: boolean
}

const { navigateToLocalized } = useRouterUtils()

defineProps<ScratchcardSoldOutModalProps>()
</script>
